/**
 * Civil industry verticals — how firms typically scope civil / site work.
 * Stored on project scope entity as civilVerticals[] (canonical keys).
 *
 * Value keys are stable for stored projects (`infrastructure`, `structural`, etc.).
 * Labels reflect practice-group naming; descriptions draw overlap boundaries.
 */

export const CIVIL_VERTICALS_SELECTION_HINT =
  'Select the practice groups delivering work on this project — pick the team that leads each deliverable. Element types (roads, ponds, bridges) can be added in Project Settings after documents are linked.';

export const CIVIL_VERTICAL_OPTIONS = [
  {
    value: 'surveying',
    label: 'Surveying',
    description: 'Boundary, topographic, and construction layout surveys',
  },
  {
    value: 'traffic',
    label: 'Traffic',
    description: 'TIA/TIS, parking demand, and operations studies — not road geometric design',
  },
  {
    value: 'structural',
    label: 'Structural Civil',
    description: 'Bridges, culverts, retaining walls, and heavy civil foundations',
  },
  {
    value: 'infrastructure',
    label: 'Site Civil',
    description: 'Roads, grading, utilities, stormwater design, and site servicing',
  },
  {
    value: 'geotechnical',
    label: 'Geotechnical',
    description: 'Subsurface investigation and bearing recommendations — not grading design',
  },
  {
    value: 'environmental',
    label: 'Environmental',
    description: 'EA, permitting, and ecology — not physical stormwater pond design',
  },
];

export function formatCivilVerticalsLabel(keys) {
  if (!keys?.length) return '';
  return keys
    .map((k) => CIVIL_VERTICAL_OPTIONS.find((o) => o.value === k)?.label || k)
    .filter(Boolean)
    .join(', ');
}
